var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_wrap"},[_c('div',{staticClass:"warp_box clearfix"},[_c('div',{staticClass:"left_box"},[_c('div',{staticClass:"title"},[_vm._v("API说明")]),_vm._v(" "),_c('div',{staticClass:"list",domProps:{"innerHTML":_vm._s(_vm.html)}})]),_vm._v(" "),_c('api-content',{attrs:{"content":_vm.content,"fileName":_vm.fileName}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75faca53","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/ResourceCenter.vue
// module id = pO/G
// module chunks = 1